import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInbox,
  faFolderOpen,
  faEuroSign,
  faStream,
  faStamp,
} from "@fortawesome/free-solid-svg-icons";

import { getCurrencyValue } from "../../../utils/general";

const TYPE_META = {
  mission:  { icon: faInbox,      title: "Mission reçue" },
  closing:  { icon: faFolderOpen, title: "Dépôt dossier" },
  honorary: { icon: faEuroSign,   title: "Facturation" },
  sd29:     { icon: faStamp,      title: "SD29 envoyé" },
};

function formatCurrency(value) {
  return getCurrencyValue(value || 0);
}

function renderEvent(ev) {
  const meta = TYPE_META[ev.isSD29 ? "sd29" : ev.type] || TYPE_META.mission;
  const variant = ev.isSD29 ? "sd29" : ev.type;

  let body;
  let amount = null;

  if (ev.type === "mission") {
    body = (
      <>
        <div className="lt-event-title">
          {meta.title} — <b>{ev.companyName || "—"}</b>
        </div>
        <div className="lt-event-sub">Dossier #{ev.folderId}</div>
      </>
    );
  } else if (ev.type === "closing") {
    body = (
      <>
        <div className="lt-event-title">
          {ev.isSD29 ? "SD29 envoyé" : "Dépôt dossier"} —{" "}
          <b>{ev.agencyName || "—"}</b>
        </div>
        <div className="lt-event-sub">
          Dossier #{ev.folderId}
          {ev.expertName ? ` • ${ev.expertName}` : ""}
        </div>
      </>
    );
    if (ev.totalReport) amount = formatCurrency(ev.totalReport);
  } else if (ev.type === "honorary") {
    body = (
      <>
        <div className="lt-event-title">
          Facturation — <b>{ev.companyName || "—"}</b>
        </div>
        <div className="lt-event-sub">{ev.agencyName || "—"}</div>
      </>
    );
    amount = formatCurrency(ev.value);
  }

  return (
    <div key={ev.id} className={`lt-event lt-event--${variant}`}>
      <div className="lt-event-icon">
        <FontAwesomeIcon icon={meta.icon} />
      </div>
      <div className="lt-event-body">{body}</div>
      {amount ? <div className="lt-event-amount">{amount}</div> : <span />}
    </div>
  );
}

export default function LiveFeed({ events }) {
  return (
    <div className="lt-panel">
      <div className="lt-panel-title">
        <span className="lt-panel-title-left">
          <FontAwesomeIcon icon={faStream} />
          Flux d'activité — aujourd'hui
        </span>
        <span>{events?.length || 0} événements</span>
      </div>
      <div className="lt-feed">
        {!events || events.length === 0 ? (
          <div className="lt-feed-empty">
            En attente de données… La journée n'a pas encore généré d'activité.
          </div>
        ) : (
          events.map(renderEvent)
        )}
      </div>
    </div>
  );
}
